import * as types from "../../actions/groups/types";

const initialState = {
  isInitialLoaded: false,
  isInitialFetching: false,
  hasFetchError: false,
  initialList: [],
  autocomplete: {},
};

export default function groups(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_INITIAL_GROUPS_REQUEST: {
      return Object.assign({}, state, {
        isInitialFetching: true,
        hasFetchError: false,
      });
    }
    case types.FETCH_INITIAL_GROUPS_SUCCESS: {
      return Object.assign({}, state, {
        isInitialFetching: false,
        isInitialLoaded: true,
        initialList: action.groups,
      });
    }
    case types.FETCH_INITIAL_GROUPS_FAILURE: {
      return Object.assign({}, state, {
        isInitialFetching: false,
        isInitialLoaded: false,
        hasFetchError: true,
      });
    }

    case types.FETCH_AUTOCOMPLETE_GROUPS_REQUEST: {
      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: {
          isFetching: true,
          isLoaded: false,
          list: [],
        },
      });

      return Object.assign({}, state, { autocomplete });
    }

    case types.FETCH_AUTOCOMPLETE_GROUPS_SUCCESS: {
      const queryState = Object.assign({}, state.autocomplete[action.query], {
        isFetching: false,
        isLoaded: true,
        list: action.groups,
      });

      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: queryState,
      });

      return Object.assign({}, state, { autocomplete });
    }

    case types.FETCH_AUTOCOMPLETE_GROUPS_FAILURE: {
      const autocomplete = Object.assign({}, state.autocomplete, {
        [action.query]: {
          isFetching: false,
          isLoaded: false,
          list: [],
        },
      });

      return Object.assign({}, state, { autocomplete });
    }

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/groups/index.js